export const CONSONANT_VOWEL_PAIRS_H = [

    // ㅎ
    {
        id: 1,
        korean: "하",
        english: "ha",

    },
    {
        id: 2,
        korean: "헤",
        english: "he",

    },
    {
        id: 3,
        korean: "히",
        english: "hi",

    },
    {
        id: 4,
        korean: "호",
        english: "ho",

    },
    {
        id: 5,
        korean: "흐",
        english: "heu",

    },
    {
        id: 6,
        korean: "허",
        english: "heo",

    },
    {
        id: 7,
        korean: "햐",
        english: "hya",

    },
    {
        id: 8,
        korean: "해",
        english: "hae",

    },
    {
        id: 9,
        korean: "혜",
        english: "hye",

    },
    {
        id: 10,
        korean: "효",
        english: "hyo",

    },
    {
        id: 11,
        korean: "혀",
        english: "hyeo",

    },
    {
        id: 12,
        korean: "휴",
        english: "hyu",

        

    },

    {
        id: 13,
        korean: "한",
        english: "han",

        

    },
    {
        id: 14,
        korean: "학",
        english: "hak",

        

    },
    {
        id: 15,
        korean: "힘",
        english: "him",
        

    },
    {
        id: 16,
        korean: "핫",
        english: "hat",
        

    },
    {
        id: 17,
        korean: "핳",
        english: "hah",
        

    },
    {
        id: 18,
        korean: "헙",
        english: "heob",
        

    },
          {
        id: 19,
        korean: "흘",
        english: "heul",
        

    },
    {
        id: 20,
        korean: "핱",
        english: "hat",
        

    },
    {
        id: 21,
        korean: "핶",
        english: "haekk",
        

    },
    {
        id: 22,
        korean: "핸",
        english: "haen",
        

    },
    {
        id: 23,
        korean: "희",
        english: "hui",
        

    },
    {
        id: 24,
        korean: "훠",
        english: "hwo",
        

    },

    {
        id: 25,
        korean: "햧",
        english: "hyat",
        

    },
    {
        id: 26,
        korean: "핱",
        english: "hat",
        

    },
    {
        id: 27,
        korean: "항",
        english: "hang",
        
    },   
    {
        id: 28,
        korean: "훨",
        english: "hwol",
        
    }
    
    
];

